export default "__VITE_ASSET__49dff5ff__"